import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const CreatePurchaseIndent = createModule({
  base: 'CREATE_PURCHASE_INDENT',
  apiDetails: SERVICE_ENDPOINT.CREATE_PURCHASE_INDENT,
  enableNotification: true,

});

const UpdatePurchaseIndent = createModule({
  base: 'UPDATE_PURCHASE_INDENT',
  apiDetails: SERVICE_ENDPOINT.UPDATE_PURCHASE_INDENT,
  enableNotification: true,

});

const GetPurchaseIndent = createModule({
  base: 'GET_PURCHASE_INDENT',
  apiDetails: SERVICE_ENDPOINT.GET_PURCHASE_INDENT({}),
});

const GetPurchaseIndents = createModule({
  base: 'GET_PURCHASE_INDENTS',
  apiDetails: SERVICE_ENDPOINT.GET_PURCHASE_INDENTS,
});

const GetPurchaseIndentList = createModule({
  base: 'GET_PURCHASE_INDENT_LIST',
  apiDetails: SERVICE_ENDPOINT.GET_PURCHASE_INDENT_LIST,
});

const UpdatePurchaseIndentStatus = createModule({
  base: 'UPDATE_PURCHASE_INDENT_STATUS',
  apiDetails: SERVICE_ENDPOINT.UPDATE_PURCHASE_INDENT_STATUS,
  enableNotification: true,
});

const GetPurchaseIndentWorkflows = createModule({
  base: 'GET_PURCHASE_INDENT_WORKFLOWS',
  apiDetails: SERVICE_ENDPOINT.WORKFLOWS,
  enableNotification: true,
});
const PurchaseIndentApprovalWorkflow = createModule({
  base: 'PURCHASE_INDENT_APPROVAL_WORKFLOW',
  apiDetails: SERVICE_ENDPOINT.PURCHASE_INDENT_APPROVAL_WORKFLOW,
  enableNotification: true,
});

export { CreatePurchaseIndent, UpdatePurchaseIndent, GetPurchaseIndent, GetPurchaseIndents, GetPurchaseIndentList, UpdatePurchaseIndentStatus, GetPurchaseIndentWorkflows, PurchaseIndentApprovalWorkflow };
